<div class="n-breadcrumb d-flex align-items-center justify-content-between">
  <ol class="breadcrumb m-0 bg-transparent p-0">
    <li class="breadcrumb-item"><a href="/#/dealer/home">Home</a></li>
    <li class="breadcrumb-item active">Manage Subscriptions</li>
  </ol>
</div>
<div class="panel-tile main-title d-flex align-items-center justify-content-between">
  <h3 style="border: 0px !important;margin: 0;padding: 0 !important;" i18n>Manage Subscriptions </h3>
  <button class="btn btn-primary" (click)="AddSubscriber('0')">
    <i _ngcontent-c12="" class="icon wb-plus"></i>&nbsp; Add Subscription
  </button>
</div>
<div class="panel-group search-criteria mb-1" id="accordion" role="tablist" aria-multiselectable="true">
  <div class="panel panel-default bg-white m-0">
    <div class="panel-heading" role="tab" id="headingTwo" (click)="seachClick(show=!show)"  data-toggle="collapse"
    data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
      <h6 class="panel-title1 d-flex align-items-center justify-content-between"
        style="padding: 11px 15px; line-height: 1.1; font-size: 15px;">
        <span>Search Criteria</span>
        <a class="collapsed" role="button" style="font-size: 22px;">
          <i class="{{toggleClass}}"></i>
        </a>
      </h6>
    </div>
    <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
      <div class="d-flex p-2 ">
        <div class="d-inline-block m-2">
          <select class="form-control" [(ngModel)]="client" (change)="bindClientSubscriptionsInfo()">
            <option value="-1" selected>All Clients</option>
            <option *ngFor="let client of clients" [value]="client.ClientId">
              {{client.ClientName}}</option>
          </select>
        </div>
        <div class="d-inline-block m-2 ">
          <div class="input-group mb-3">
            <input type="text" class="form-control" [(ngModel)]="searchText" placeholder="Search"
              aria-label="Recipient's username"  (keyup.enter)="bindClientSubscriptionsInfo()"  aria-describedby="button-addon2">
            <div class="input-group-append">
              <button class="btn btn-primary" (click)="bindClientSubscriptionsInfo()" type="submit"
                id="button-addon2">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="tcard" style="box-shadow: 0 0 0 #eee;">
  <div class="tcard-body">
    <div class="prime-table p-0">
      <p-table #cs [columns]="subscriberCols" [value]="subscribers" [rows]="20" [responsive]="true"
        class="mytable table-search"
        [globalFilterFields]="['SubscriptionName','ClientName','SubscriptionTypeName','SourceName']" [paginator]="true"
        [pageLinks]="3" [rowsPerPageOptions]="[5,10,20]" [sortField]="['ClientName']" [sortOrder]="1">
        <ng-template pTemplate="colgroup">
          <colgroup>
              <col style="width:3%">
              <col style="width:5%">
              <col style="width:13%">
              <col style="width:5%">
              <col style="width:5%">
              <col style="width:5%">
              <col style="width:7%">
              <col style="width:5%">
            </colgroup>
        </ng-template>
        <ng-template pTemplate="body" let-rowData  let-expanded="expanded">
          <tr>
            <td>
              <div class="tcol-actions">
                <span class="action-edit text-primary">
                  <i class="flaticon2-writing" title="Edit" (click)="AddSubscriber(rowData.ClientSubscriptionGuid)"></i>
                </span>
                <span class="action-delete text-danger"  *ngxPermissionsOnly="['SuperAdmin','Admin']">
                  <i class="flaticon-delete-1" title="Delete"
                    (click)="onDeleteSubscription(rowData.ClientSubscriptionId)"></i>
                </span>
              </div>
            </td>
            <td>{{rowData.ClientName}}</td>
            <td>{{rowData.SubscriptionName}}</td>
            <td style="text-align: center;">
              <a title="Subscribed Dealers" (click)="getDealersList(rowData.ClientSubscriptionGuid)" href="javascript:void(0)">{{rowData.DealerCount}}</a>
            </td>
            <td>{{rowData.SubscriptionTypeName}}</td>
            <td>{{rowData.SourceName}}</td>
            <td>{{rowData.FileTypes}}</td>
            <td>{{rowData.ScheduleType}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
              {{col.header}}
              <span *ngIf="col.field != 'Actions' && col.field != 'Expand'">
              </span>
            </th>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<p-dialog class="confirm-delete-modal required-modal" header="Delete Subscription" [(visible)]="displaySubDltDialog"
  [responsive]="true" showEffect="fade" [modal]="true">
  <div class="col-md-12" style="padding-bottom: 20px;">
    <div class="row">
      <div class="form-group col-md-12">
        Are you sure you want to delete this subscription?
      </div>
    </div>
  </div>
  <p-footer class="req-footer">
    <div>
      <button type="submit" class="btn btn-light my-2 py-3 px-5" (click)="No()" href="javascript:;">No</button>
      <button type="submit" class="btn btn-primary my-2 py-3 px-5" (click)="Yes()" href="javascript:;">Yes</button>
    </div>
  </p-footer>
</p-dialog>
<style>
  .table-bordered {
    border: 0px;
  }

  .mytable1 th:nth-child(2) {
    width: 570px;
  }

  .mytable1 th:nth-child(4) {
    width: 98px;
  }

  .mytable1 th:nth-child(5) {
    width: 134px;
  }

  .ui-tabview-panels {
    min-height: 280px !important;
    max-height: 400px !important;
  }
</style>